/** The page's tabs, shared with the app's sidebar group so both list the same sub-pages. */
export const environmentSettingsTabs = [
  {
    id: 'overview',
    label: 'Overview',
    icon: 'dashboard',
    href: '/environments/overview',
    matchStrategy: 'prefix' as const,
  },
  {
    id: 'timeline',
    label: 'Timeline',
    icon: 'timeline',
    href: '/environments/timeline',
    matchStrategy: 'prefix' as const,
  },
  {
    id: 'environment',
    label: 'Environment Details',
    icon: 'dns',
    href: '/environments/env',
    matchStrategy: 'prefix' as const,
  },
  {
    id: 'feature-flags',
    label: 'Feature Flags',
    icon: 'flag',
    href: '/environments/feature-flags',
    matchStrategy: 'prefix' as const,
  },
  {
    id: 'ip-gateways',
    label: 'IP Gateways',
    icon: 'nat',
    href: '/environments/ip-gateways',
    matchStrategy: 'prefix' as const,
  },
];

// An `account/env` name keeps its slash: the env route takes the rest of the path.
export const envHref = (name: string) =>
  `/environments/env/${name.split('/').map(encodeURIComponent).join('/')}`;
